/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Size_SystemInputs */

const en_field_size_system = /** @type {(inputs: Field_Size_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sizing System`)
};

const es_field_size_system = /** @type {(inputs: Field_Size_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sistema de tallas`)
};

const fr_field_size_system = /** @type {(inputs: Field_Size_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Système de taille`)
};

const de_field_size_system = /** @type {(inputs: Field_Size_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Größensystem`)
};

const ja_field_size_system = /** @type {(inputs: Field_Size_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サイズ体系`)
};

const zh_field_size_system = /** @type {(inputs: Field_Size_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尺码系统`)
};

const ar_field_size_system = /** @type {(inputs: Field_Size_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نظام المقاسات`)
};

const id_field_size_system = /** @type {(inputs: Field_Size_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sistem Ukuran`)
};

const it_field_size_system = /** @type {(inputs: Field_Size_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sistema di Taglie`)
};

const ru_field_size_system = /** @type {(inputs: Field_Size_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Система размеров`)
};

const pt_field_size_system = /** @type {(inputs: Field_Size_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sistema de Tamanho`)
};

const ko_field_size_system = /** @type {(inputs: Field_Size_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`사이즈 체계`)
};

/**
* | output |
* | --- |
* | "Sizing System" |
*
* @param {Field_Size_SystemInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_size_system = /** @type {((inputs?: Field_Size_SystemInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Size_SystemInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_size_system(inputs)
	if (locale === "es") return es_field_size_system(inputs)
	if (locale === "fr") return fr_field_size_system(inputs)
	if (locale === "de") return de_field_size_system(inputs)
	if (locale === "ja") return ja_field_size_system(inputs)
	if (locale === "zh") return zh_field_size_system(inputs)
	if (locale === "ar") return ar_field_size_system(inputs)
	if (locale === "id") return id_field_size_system(inputs)
	if (locale === "it") return it_field_size_system(inputs)
	if (locale === "ru") return ru_field_size_system(inputs)
	if (locale === "pt") return pt_field_size_system(inputs)
	return ko_field_size_system(inputs)
});